// ==============================
// File: src/pages/Help.jsx
// ==============================
import React from "react";

export default function Help() {
  return (
    <div style={{ padding: 16, color: "#fff" }}>
      <h2 style={{ marginBottom: 8 }}>Help & Support</h2>
      <p style={{ opacity: 0.8, marginBottom: 16 }}>
        Find quick answers, tips, and ways to contact us.
      </p>

      <div
        style={{
          display: "grid",
          gap: 12,
          gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
        }}
      >
        <Card title="Getting Started" body="Basics of planning, batches, and materials." />
        <Card title="Billing & Plans" body="How subscriptions and limits work." />
        <Card title="Workshops" body="Create, publish, and manage bookings." />
        <Card title="Contact Support" body={<>
          Email us at{" "}
          <a href="mailto:support@mudo.app" style={{ color: "#d1e7ff" }}>
            support@mudo.app
          </a>
        </>} />
      </div>
    </div>
  );
}

function Card({ title, body }) {
  return (
    <div
      style={{
        padding: "14px",
        borderRadius: 12,
        background: "rgba(255,255,255,0.06)",
        border: "1px solid rgba(255,255,255,0.12)",
      }}
    >
      <h3 style={{ margin: 0, marginBottom: 6, fontSize: 16 }}>{title}</h3>
      <p style={{ margin: 0, opacity: 0.85, fontSize: 13 }}>
        {body}
      </p>
    </div>
  );
}
